import { defineMessages } from 'react-intl';

export default defineMessages({
  commonSnackbarSupportMessageSentSuccessfully: {
    defaultMessage: 'Your message was successfully sent to support.',
    description: 'Common snackbar - Your message was successfully sent to support',
    id: 'commonSnackbarSupportMessageSentSuccessfully',
  },
});
